<template>
    <div class="multiselect-blade-trigger">
        <pendo-multiselect
            full-width
            :append-to-body="false"
            :options="[]"
            popup-type="dialog"
            @open="openBlade">
            <template #trigger="{ comboboxAttrs, setTriggerRef, triggerSize }">
                <pendo-multiselect-trigger
                    v-bind="comboboxAttrs"
                    :ref="setTriggerRef"
                    :trigger-size="triggerSize"
                    is-full-width
                    tabindex="0"
                    role="button"
                    max-trigger-width="400px"
                    @click="openBlade"
                    @keydown.enter.prevent="openBlade"
                    @keydown.space.prevent="openBlade">
                    <div class="pendo-multiselect__value">
                        <div v-if="numSelected === 0">
                            Select activity source
                        </div>
                        <div
                            v-else-if="numSelected === 1"
                            class="multiselect-blade-trigger-single">
                            <pendo-icon-option
                                class="multiselect-blade-trigger-single"
                                :option="singleSelectedOption" />
                        </div>
                        <div
                            v-else-if="!isApp && !isProductArea"
                            class="multiselect-blade-trigger-multi">
                            Events ({{ numSelected }})
                        </div>
                        <div
                            v-else
                            class="multiselect-blade-trigger-multi">
                            <span
                                v-if="appList.numHidden > 0"
                                class="multiselect-blade-trigger-multi-overflow">
                                +{{ appList.numHidden }}</span>
                            {{ appList.list }}
                        </div>
                    </div>
                </pendo-multiselect-trigger>
            </template>
        </pendo-multiselect>
    </div>
</template>
<script>
import { PendoMultiselect, PendoMultiselectTrigger, PendoIconOption } from '@pendo/components';
import lowerFirst from 'lodash/lowerFirst';
import getWidth from '@/utils/string-pixel-width/string-pixel-width';

const MAX_WIDTH = 356;

export default {
    name: 'MultiselectBladeTrigger',
    components: {
        PendoMultiselect,
        PendoMultiselectTrigger,
        PendoIconOption,
    },
    props: {
        selectedTargets: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['multiselect-blade-trigger-open'],
    computed: {
        numSelected () {
            return this.selectedTargets.length;
        },
        isProductArea () {
            return this.firstSelection.kind === 'productArea';
        },
        isApp () {
            return this.firstSelection.kind === 'anyActivity';
        },
        firstSelection () {
            return this.selectedTargets[0];
        },
        singleSelectedOption () {
            const label = this.firstSelection.name;
            const icon = this.isProductArea ? this.firstSelection.icon : { type: this.firstIconType };

            return { label, icon };
        },
        firstIconType () {
            const iconName = this.isApp ? this.firstSelection.platform : this.firstSelection.kind;

            switch (iconName) {
                case 'trackEvent':
                    return 'zap';
                case 'extension':
                    return 'puzzle-piece';
                default:
                    return lowerFirst(iconName);
            }
        },
        appList () {
            let appListPixels = 0;
            let overflowIndex = 0;

            const nameList = this.selectedTargets.map((target, index) => {
                appListPixels += getWidth(`${target.name}, `, { font: 'inter', size: 14 });

                if (appListPixels > MAX_WIDTH && overflowIndex === 0) {
                    overflowIndex = index + 1;
                }

                return target.name;
            });
            const numHidden = overflowIndex > 0 ? nameList.length - overflowIndex : 0;

            return { list: nameList.join(', '), numHidden };
        },
    },
    methods: {
        openBlade () {
            this.$emit('multiselect-blade-trigger-open');
        },
    },
};
</script>
<style lang="less" scoped>
.multiselect-blade-trigger {
    display: flex;
    flex-direction: column;

    &-single {
        display: flex;
        flex-direction: row;
    }
    &-multi {
        text-overflow: ellipsis;
        overflow: hidden;
        &-overflow {
            float: right;
        }
    }
    :deep(.pendo-picker-popper__content-wrapper) {
        display: none !important;
    }
}
</style>
